import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import PortalLayout from './Pages/Layouts/PortalLayout.vue'
import PrimeVue from 'primevue/config';
import Wind from '@/PrimeVuePresets/wind';
import ToastService from 'primevue/toastservice';
import 'primevue/resources/themes/lara-light-purple/theme.css';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import VueCookies from 'vue-cookies'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import {MotionPlugin} from '@vueuse/motion';
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCheck, faPencil, faTrashCan, faChevronLeft, faChevronRight, faSort, faImage, faPlus, 
        faCommentLines, faCopy, faComment, faPhone, faEnvelope, faMapLocationDot, faTriangleExclamation,
        faList, faEquals, faMinus, faEye, faFileInvoice, faCars, faCircleUser, faCalendarDay, faCircleQuestion,
        faCircleCheck, faHeart, faMagnifyingGlass, faChevronDown, faEllipsis, faCircleInfo, 
 } from '@awesome.me/kit-8b7bad3074/icons/classic/light'
import {
    faInbox as faInboxRegular, faXmark as faXmarkRegular, faBars as faBarsRegular, faBell as faBellRegular, faEnvelope as faEnvelopeRegular,
    faChevronsLeft as faChevronsLeftRegular, faChevronsRight as faChevronsRightRegular, faChevronLeft as faChevronLeftRegular,
    faChevronRight as faChevronRightRegular, faChevronDown as faChevronDownRegular, faChevronUp as faChevronUpRegular,
    faDoNotEnter as faDoNotEnterRegular, faHouse as faHouseRegular, faMagnifyingGlass as faMagnifyingGlassRegular,
    faHeart as faHeartRegular, faCar as faCarRegular, faCarGarage as faCarGarageRegular, faGavel as faGavelRegular,
    faCarBuilding as faCarBuildingRegular, faFileInvoice as faFileInvoiceRegular, faUsers as faUsersRegular, faBuildingShield as faBuildingShieldRegular,
    faUserGroupCrown as faUserGroupCrownRegular, faCarWrench as faCarWrenchRegular, faBoxArchive as faBoxArchiveRegular,
    faArrowTrendUp as faArrowTrendUpRegular, faBriefcase as faBriefcaseRegular, faStar as faStarRegular, faHandshake as faHandshakeRegular,
    faCartShopping as faCartShoppingRegular, faTag as faTagRegular, faCalendar as faCalendarRegular, faEye as faEyeRegular,
    faFilter as faFilterRegular, faTableCellsLarge as faTableCellsLargeRegular, faTableList as faTableListRegular,
    faQuestion as faQuestionRegular, faImages as faImagesRegular, faMapLocationDot as faMapLocationDotRegular, faStopwatch as faStopwatchRegular,
    faBoltSlash as faBoltSlashRegular, faReceipt as faReceiptRegular, faTrash as faTrashRegular, faPhone as faPhoneRegular,
    faPencil as faPencilRegular, faSquareParking as faSquareParkingRegular, faGlobe as faGlobeRegular, faMoneyBillTrendUp as faMoneyBillTrendUpRegular,
    faEnvelopeOpenDollar as faEnvelopeOpenDollarRegular, faHourglassClock as faHourglassClockRegular, faCircleUser as faCircleUserRegular,
    faBellRing as faBellRingRegular, faCircleInfo as faCircleInfoRegular, faMoneyBill as faMoneyBillRegular,
    faBadgeCheck as faBadgeCheckRegular, faTriangleExclamation as faTriangleExclamationRegular, faCircleQuestion as faCircleQuestionRegular,
    faCheck as faCheckRegular, faSpinner as faSpinnerRegular, faCheckCircle as faCheckCircleRegular, faArrowUp as faArrowUpRegular, faArrowRight as faArrowRightRegular

} from '@awesome.me/kit-8b7bad3074/icons/classic/regular'
import {
     faHeart as faHeartSolid, faChevronLeft as faChevronLeftSolid, faChevronRight as faChevronRightSolid, faShare as faShareSolid,
     faCircleUser as faCircleUserSolid, faMoneyBill as faMoneyBillSolid, faTag as faTagSolid, faMagnifyingGlass as faMagnifyingGlassSolid,
     faBoltSlash as faBoltSlashSolid, faPhone as faPhoneSolid, faBell as faBellSolid, faStar as faStarSolid, faStarHalf as faStarHalfSolid,
     faStarHalfStroke as faStarHalfStrokeSolid, faArrowRight as faArrowRightSolid, faEnvelope as faEnvelopeSolid,
     faStopwatch as faStopwatchSolid, faBuildingShield as faBuildingShieldSolid, faHandshake as faHandshakeSolid, faCircleEuro as faCircleEuroSolid, 
     faListCheck as faListCheckSolid, faArrowRightLong as faArrowRightLongSolid, faHeadset as faHeadsetSolid,
     faCommentsDollar as faCommentsDollarSolid, faHandHoldingCircleDollar as faHandHoldingCircleDollarSolid,    
} from '@awesome.me/kit-8b7bad3074/icons/classic/solid'
import {
    faWhatsapp as faWhatsappBrands,
    faInstagram as faInstagramBrands,
    faFacebook as faFacebookBrands
} from '@awesome.me/kit-8b7bad3074/icons/classic/brands'
import VueCountdown from '@chenfengyuan/vue-countdown';
import * as Sentry from "@sentry/vue";

createInertiaApp({
    title: (title) => title ? `${title} | mijnautosnelweg.nl` : 'mijnautosnelweg.nl',
    resolve: name => {
        const pages = import.meta.glob(['./Pages/*.vue', './Pages/**/*.vue', './Pages/**/**/*.vue'], { eager: true })
        let page = pages[`./Pages/${name}.vue`]
        if (name.startsWith('Portal')) {
            page.default.layout = name.startsWith('Portal/Auth/') ? undefined : PortalLayout
        } else {
            page.default.layout = undefined;
        }
        return page
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) }).use(plugin);
        library.add(
            //light icons
            faCheck, faPencil, faTrashCan, faChevronLeft, faChevronRight, faSort, faImage, faPlus,
            faCommentLines, faCopy, faComment, faPhone, faEnvelope, faMapLocationDot, faTriangleExclamation,
            faList, faEquals, faMinus, faEye, faFileInvoice, faCars, faCircleUser, faCalendarDay, faCircleQuestion,
            faCircleCheck, faHeart, faMagnifyingGlass, faChevronDown, faEllipsis, faCircleInfo,

            //regular icons
            faInboxRegular, faXmarkRegular, faBarsRegular, faBellRegular, faChevronsLeftRegular, faChevronsRightRegular,
            faChevronLeftRegular, faChevronRightRegular, faChevronDownRegular, faChevronUpRegular, faDoNotEnterRegular,
            faHouseRegular, faMagnifyingGlassRegular, faHeartRegular, faCarRegular, faCarGarageRegular, faGavelRegular,
            faCarBuildingRegular, faFileInvoiceRegular, faUsersRegular, faUserGroupCrownRegular, faCarWrenchRegular,
            faBoxArchiveRegular, faArrowTrendUpRegular, faBriefcaseRegular, faStarRegular, faCartShoppingRegular, faHandshakeRegular,
            faTagRegular, faCalendarRegular, faEyeRegular, faFilterRegular, faTableCellsLargeRegular, faTableListRegular,
            faQuestionRegular, faImagesRegular, faMapLocationDotRegular, faBoltSlashRegular, faReceiptRegular, faStopwatchRegular,
            faTrashRegular, faPhoneRegular, faPencilRegular, faSquareParkingRegular, faGlobeRegular, faMoneyBillTrendUpRegular,
            faEnvelopeOpenDollarRegular, faHourglassClockRegular, faCircleUserRegular, faBellRingRegular, faCircleInfoRegular,
            faMoneyBillRegular, faBadgeCheckRegular, faTriangleExclamationRegular, faCircleQuestionRegular, faCheckRegular,
            faSpinnerRegular, faCheckCircleRegular, faArrowUpRegular, faArrowRightRegular, faEnvelopeRegular, faBuildingShieldRegular,

            //brands
            faWhatsappBrands, faInstagramBrands, faFacebookBrands,

            // solid icons
            faHeartSolid, faChevronLeftSolid, faChevronRightSolid, faShareSolid, faCircleUserSolid, faMoneyBillSolid,
            faTagSolid, faMagnifyingGlassSolid, faBoltSlashSolid, faPhoneSolid, faBellSolid, faStarSolid, faStarHalfSolid,
            faStarHalfStrokeSolid, faArrowRightSolid, faEnvelopeSolid, faStopwatchSolid, faBuildingShieldSolid, faHandshakeSolid,
            faCircleEuroSolid, faListCheckSolid, faArrowRightLongSolid, faHeadsetSolid, faCommentsDollarSolid, faHandHoldingCircleDollarSolid,
        );

        app.component('font-awesome-icon', FontAwesomeIcon);
        app.use(MotionPlugin);
        app.use(autoAnimatePlugin);
        

        app.component(VueCountdown.name, VueCountdown);

        isSupported().then((supported) => {
            if (supported) {
                var firebaseConfig = {
                    apiKey: "AIzaSyCeXCC9kdXA3V24xlc_15M63_D5Pt_fQGU",
                    authDomain: "mijnautosnelweg-4b4f4.firebaseapp.com",
                    projectId: "mijnautosnelweg-4b4f4",
                    storageBucket: "mijnautosnelweg-4b4f4.appspot.com",
                    messagingSenderId: "538737820966",
                    appId: "1:538737820966:web:23cdf4cf952bd2c45dede7",
                    measurementId: "G-KQVNRHT4TX"
                };
    
                // Initialize Firebase
                const firebaseApp = initializeApp(firebaseConfig);
    
                if ('serviceWorker' in navigator) {
                    const messaging = getMessaging(firebaseApp);
                    onMessage(messaging, (payload) => {
                        console.log("onMessage event fired", payload)
                    });
                }
            }
        });

        //setup reverb
        window.Echo = new Echo({
            broadcaster: 'reverb',
            key: import.meta.env.VITE_REVERB_APP_KEY,
            wsHost: import.meta.env.VITE_REVERB_HOST,
            wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
            wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
            forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
            enabledTransports: ['ws', 'wss'],
        });

        Sentry.init({
            app,
            dsn: "https://636db8154cf1c58f32d947b28c6c22c4@o4508357877039104.ingest.de.sentry.io/4508834597765200",
            integrations: [
          ],
        });

        app.use(ToastService);
        app.use(VueCookies, { expires: '30d'})
        app.use(PrimeVue, {
            pt: Wind,
            locale: {
                startsWith: 'Start met',
                contains: 'Bevat',
                notContains: 'Bevat geen',
                endsWith: 'Eindigt op',
                equals: 'Gelijk aan',
                notEquals: 'Niet gelijk aan',
                noFilter: 'Geen filter',
                lt: 'Kleiner dan',
                lte: 'Kleiner dan of gelijk aan',
                gt: 'Groter dan',
                gte: 'Groter dan of gelijk aan',
                dateIs: 'Datum is',
                dateIsNot: 'Datum is niet',
                dateBefore: 'Datum is voor',
                dateAfter: 'Datum is na',
                clear: 'Legen',
                apply: 'Toepassen',
                matchAll: 'Match All',
                matchAny: 'Match Any',
                addRule: 'Regel toevoegen',
                removeRule: 'Regel verwijderen',
                accept: 'Ja',
                reject: 'Nee',
                choose: 'Kiezen',
                upload: 'Upload',
                cancel: 'Annuleren',
                completed: 'Afgerond',
                pending: 'In behandeling',
                fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                dayNames: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
                dayNamesShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
                dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
                monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'october', 'november', 'december'],
                monthNamesShort: ['jan', 'feb', 'mrt', 'arp', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
                chooseYear: 'Kies jaar',
                chooseMonth: 'Kies maand',
                chooseDate: 'Kies datum',
                prevDecade: 'Vorig decennium',
                nextDecade: 'Volgend decennium',
                prevYear: 'Vorig jaar',
                nextYear: 'Volgend jaar',
                prevMonth: 'Vorige maand',
                nextMonth: 'Volgende maand',
                prevHour: 'Vorig uur',
                nextHour: 'Volgend uur',
                prevMinute: 'Vorige minuut',
                nextMinute: 'Volgende minuut',
                prevSecond: 'Vorige seconde',
                nextSecond: 'Volgende seconde',
                am: 'am',
                pm: 'pm',
                today: 'Vandaag',
                weekHeader: 'Wk',
                firstDayOfWeek: '0',
                showMonthAfterYear: 'false',
                dateFormat: 'mm/dd/yy',
                weak: 'Zwak',
                medium: 'Redelijk',
                strong: 'Sterk',
                passwordPrompt: 'Voer een wachtwoord in',
                emptyFilterMessage: 'Geen resultaten gevonden', // @deprecated Use 'emptySearchMessage' option instea
                searchMessage: '{0} resultaten gevonden',
                selectionMessage: '{0} items geselecteerd',
                emptySelectionMessage: 'Geen geselecteerde items',
                emptySearchMessage: 'Geen resultaten gevonden',
                emptyMessage: 'Geen resultaten gevonden',
                'aria.trueLabel': 'Ja',
                'aria.falseLabel': 'Nee',
                'aria.nullLabel': 'Niet geselecteerd',
                'aria.star': '1 ster',
                'aria.stars': '{star} sterren',
                'aria.selectAll': 'Alle items selecteren',
                'aria.unselectAll': 'Alle items deselecteren',
                'aria.close': 'Sluiten',
                'aria.previous': 'Vorige',
                'aria.next': 'Volgende',
                'aria.navigation': 'Navigatie',
                'aria.scrollTop': 'Scroll Top',
                'aria.moveTop': 'Move Top',
                'aria.moveUp': 'Move Up',
                'aria.moveDown': 'Move Down',
                'aria.moveBottom': 'Move Bottom',
                'aria.moveToTarget': 'Move to Target',
                'aria.moveToSource': 'Move to Source',
                'aria.moveAllToTarget': 'Move All to Target',
                'aria.moveAllToSource': 'Move All to Source',
                'aria.pageLabel': 'Pagina {page}',
                'aria.firstPageLabel': 'Eerste pagina',
                'aria.lastPageLabel': 'Laatste pagina',
                'aria.nextPageLabel': 'Volgende pagina',
                'aria.prevPageLabel': 'Vorige pagina',
                'aria.rowsPerPageLabel': 'Regels per pagina',
                'aria.jumpToPageDropdownLabel': 'Spring naar pagina dropdown',
                'aria.jumpToPageInputLabel': 'Spring naar pagina input',
                'aria.selectRow': 'Regel selecteren',
                'aria.unselectRow': 'Regel deselecteren',
                'aria.expandRow': 'Regel uitklappen',
                'aria.collapseRow': 'Regel inklappen',
                'aria.showFilterMenu': 'Toon filter menu',
                'aria.hideFilterMenu': 'Sluit filter menu',
                'aria.filterOperator': 'Filter Operator',
                'aria.filterConstraint': 'Filter Constraint',
                'aria.editRow': 'Regel aanpassen',
                'aria.saveEdit': 'Opslaan',
                'aria.cancelEdit': 'Annuleren',
                'aria.listView': 'Lijst weergave',
                'aria.gridView': 'Grid weergave',
                'aria.slide': 'Slide',
                'aria.slideNumber': '{slideNumber}',
                'aria.zoomImage': 'Afbeelding zoom',
                'aria.zoomIn': 'Zoom in',
                'aria.zoomOut': 'Zoom uit',
                'aria.rotateRight': 'Draai rechts',
                'aria.rotateLeft': 'Draai links',
                'aria': {
                    'stars': '{rating} sterren',
                    'pageLabel': 'Pagina {page}',
                    'slideNumber': '{slideNumber}'
                },
            }
        });

        el.classList.add('h-full');
        app.mount(el);
    },
})